module.exports = __webpack_public_path__ + "img/chatbotimg5.9d6f9cf7.png";